import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
